import React from 'react';
import { Modal, Input } from 'antd';

import requestAPI from 'helpers/requestAPI';
import { toastError, toastSuccess } from 'utils/toastr';

const RegistrModal = ({ visible, changeVisible, updateRegistr, editMode, registrId }) => {
	const [ formData, setFormData ] = React.useState({
		name: '',
		username: '',
		access_token: '',
		server: ''
	});

	React.useEffect(
		() => {
			if (editMode) {
				const params = {
					routeParams: {
						route: 'domain_register',
						id: registrId
					}
				};

				requestAPI(params)
					.then((resp) => {
						return resp.data.data;
					})
					.then((data) => {
						setFormData({
							name: data.name,
							username: data.username,
							access_token: data.access_token,
							server: data.server
						});
					})
					.catch((err) => {
						toastError(err);
					});
			} else {
				setFormData({
					name: '',
					username: '',
					access_token: '',
					server: ''
				});
			}
		},
		[ editMode, registrId ]
	);

	const handleSubmit = () => {
		if (!formData.name || !formData.username || !formData.access_token || !formData.server) {
			toastError('Please fill in all fields');
			return;
		}

		const routeParams = editMode
			? {
					route: 'domain_register',
					id: registrId
				}
			: {
					route: 'domain_register'
				};

		const params = {
			routeParams,
			method: editMode ? 'PUT' : 'POST',
			data: {
				...formData
			}
		};

		requestAPI(params)
			.then(() => {
				editMode ? toastSuccess('Edited!') : toastSuccess('Added!');
				updateRegistr();
				changeVisible();
			})
			.catch((err) => toastError(err));
	};

	const handleChangeInput = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value })
	}

	return (
		<Modal
			title={editMode ? 'Edit registrar properties' : 'Add new registrar'}
			visible={visible}
			onOk={handleSubmit}
			onCancel={changeVisible}
		>
			<span>Name: </span>
			<Input name='name' onChange={handleChangeInput} value={formData.name} />
			<span>Username: </span>
			<Input name='username' onChange={handleChangeInput} value={formData.username} />
			<span>Token: </span>
			<Input name ='access_token'
				onChange={handleChangeInput}
				value={formData.access_token}
			/>
			<span>Server: </span>
			<Input name='server' onChange={handleChangeInput} value={formData.server} />
		</Modal>
	);
};

export default RegistrModal;
